import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import AppCognito from "./AppCognito";
import { BrowserRouter as Router } from "react-router-dom";
import history from "./utils/history";
import * as serviceWorker from "./serviceWorker";

const AppComponent = process.env.REACT_APP_COGNITO === 'true' ? AppCognito : App;

ReactDOM.render(
  <Router history={history}>
    <AppComponent />
  </Router>,
  document.getElementById("root")
);

serviceWorker.unregister();
